/* eslint-disable ember/no-classic-components, getter-return */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';

import { dasherize } from '@ember/string';
import { htmlSafe } from '@ember/template';
import { isEmpty } from '@ember/utils';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class AppOptionsFeatureRow extends Component {
  // tableBody must be a reference to the paper-data-table body.
  tableBody = null;

  // label is the label to show for this feature.
  @tracked label = '';

  // available determines whether this feature is available to the school.
  @tracked available = false;

  // enabled determines whether this feature is enabled/used by the school.
  @tracked enabled = false;

  // info is displayed in the "Information" column next to the status
  @tracked info = null;

  // promoInfo indicates whether the "Information" column will link to
  // a Hubspot page if the feature is not available
  @tracked promoInfo = false;

  // alwaysShowInfo is a flag that indicates whether the text in the Info column
  // should always display regardless of the status
  @tracked alwaysShowInfo = false;

  // status returns the right status for this feature to display
  get status() {
    let status = '';
    if (this.available) {
      if (!this.enabled) {
        status = 'Available';
      } else {
        // Enabled is both available and enabled
        status = 'Enabled';
      }
    } else {
      if (!this.enabled) {
        status = 'Upgrade now';
      } else {
        // For school bookings specifically - we don't have logic to check for its availability yet
        status = 'Enabled';
      }
    }

    return status;
  }

  // infoText returns the correct information to display
  get infoText() {
    if (!isEmpty(this.info)) {
      if (this.alwaysShowInfo) {
        // For Term Dates and School Details in particular
        return this.info;
      }
      if (this.available && !this.enabled) {
        return this.info;
      }
    }

    if (this.promoInfo) {
      if (!(this.available || this.enabled)) {
        // For "Report Absence" and "School Bookings"
        // These features have their own Hubspot pages
        let dasherizedLabel = dasherize(this.label);
        return htmlSafe(`
          <a target="_blank" href="https://info.our-hero.com/app/${dasherizedLabel}">
            Find out more about this feature.
          </a>
        `);
      } else {
        // For school bookings specifically
        return '';
      }
    }
  }
}
